<template>
    <div v-tooltip="disabled ? 'This sentence part cannot be deleted.' : ''"
         @click="onClick"
         class="delete-btn"
         :class="{'disabled': disabled}">
        <i class="fal fa-trash-alt"></i>
    </div>
</template>

<script>
export default {
    name: 'AutomationEditorSentencePartDeleteBtn',
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClick() {
            if (this.disabled) {
                return
            }
            this.$emit('delete')
        }
    }
}
</script>

<style scoped lang="scss">
    @import '../index';
</style>
